/**
 * @description 프린터 설정 페이지
 */
import { useEffect } from "react";
import { inject, observer } from "mobx-react";

import SettingDefaultPrinterSetView from "./sections/SettingDefaultPrinterSetView";
import SettingEtcPrinterSetView from "./sections/SettingEtcPrinterSetView";
import SettingOutPrinterSetView from "./sections/SettingOutPrinterSetView";
import { fn_print_set_type } from "function/FnBodyLayer";
import { fn_payfree_info } from "function/FnBodySetting";
import { origin_info_item } from "http/DetailConn";
import printImg from "static-file/images/print_default.png";
import SettingWrapper from "views/setting/components/wrappers/SettingWrapper";

// 미결제 사용자 프롬프트 컴포넌트
const PaymentPromptView = ({ rootStore }: { rootStore: any }) => (
  <div className="scroll">
    <div className="inner">
      <div className="list_delivery_none img">
        <img src={printImg} alt="print_default.png" useMap="#link" width="100%" />
        <map name="link">
          <area
            shape="rect"
            coords="168,537,446,585"
            href="#"
            onClick={() =>
              fn_payfree_info(
                rootStore,
                "https://delivery.okpos.co.kr/?utm_source=free_month&utm_medium=print&utm_campaign=basic_plan",
                "mktPrinterSetup Button"
              )
            }
            alt="1monthFree"
          />
        </map>
      </div>
    </div>
  </div>
);

const SettingDefaultPrinterView = ({ rootStore }: { rootStore: any }) => {
  const { settingStore, layerStore } = rootStore;
  const { getShopApiSetting } = settingStore;
  const { getLayerPrintSetTypeView } = layerStore;

  // 프린터 설정 페이지 미결제 사용자 체크
  const notPaymentUser = rootStore.settingStore.getPayFreeType.paymentUseYn === "0";

  // 제휴사 중 하나라도 연동되어 있으면 보여짐
  const canViewContent = () => {
    return (
      Object.values(getShopApiSetting).some(value => value === "Y") ||
      settingStore.getYgyUseStatus === "Y" ||
      settingStore.getBaeminUseStatus.isCurrentPosBaeminUse === "Y" ||
      settingStore.getPrinterInfo.usedVirtualModeExceptPrint === "Y"
    );
  };

  // 탭 컴포넌트
  const TabsConfig = [
    {
      label: "주문 인식 프린터",
      isActive: getLayerPrintSetTypeView === "default",
      isView: true,
      onClick: () => fn_print_set_type(rootStore, "default"),
    },
    {
      label: "연동 출력 프린터",
      isActive: getLayerPrintSetTypeView === "etc",
      isView: canViewContent(),
      onClick: () => fn_print_set_type(rootStore, "etc"),
    },
    {
      label: "연동 출력물 설정",
      isActive: getLayerPrintSetTypeView === "out",
      isView: canViewContent(),
      onClick: () => {
        fn_print_set_type(rootStore, "out");
        origin_info_item(rootStore);
      },
    },
  ];

  // 프린터 설정 컴포넌트
  const SettingsContent = observer(
    ({ rootStore, isIntegrationContentVisible }: { rootStore: any; isIntegrationContentVisible: boolean }) => {
      if (getLayerPrintSetTypeView === "default") {
        return <SettingDefaultPrinterSetView rootStore={rootStore} />;
      }
      if (isIntegrationContentVisible && getLayerPrintSetTypeView === "etc") {
        return <SettingEtcPrinterSetView rootStore={rootStore} />;
      }
      if (isIntegrationContentVisible && getLayerPrintSetTypeView === "out") {
        return <SettingOutPrinterSetView rootStore={rootStore} />;
      }
      return null;
    }
  );

  // 페이지 진입 시 메뉴 설정
  useEffect(() => {
    settingStore.setSettingUseMenu("printer_setting");
    settingStore.setSettingView(false);
  }, []);

  return (
    <SettingWrapper title="프린터 설정" rootStore={rootStore} tabs={TabsConfig}>
      {notPaymentUser ? (
        <PaymentPromptView rootStore={rootStore} />
      ) : (
        <SettingsContent rootStore={rootStore} isIntegrationContentVisible={canViewContent()} />
      )}
    </SettingWrapper>
  );
};

export default inject("rootStore")(observer(SettingDefaultPrinterView));
